<template>
    <div>
        <cityinfo-header></cityinfo-header>
        <div class="inner-banner">
            <section class="w3l-breadcrumb">
                <div class="container py-md-4">
                    <div class="title-heading-w3 text-center mx-auto">
                        <h3 class="title-main" >{{title}}</h3>
                        <div class="mt-4 sub-title text-center">
                            <h4 class="mark-s">表單下載</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section class="w3l-form-26">
		<div class="w3l-new-block-6 py-5">
			<div class="container py-md-4 py-3">
                <div class="form-inner-cont">
                    <div class="row mt-md-5 mt-3 text-left">
                        <label class="col-md-1">類別：</label>
                        <div class="col-md-3">
                            <select class="form-control" v-model="fileClass" @change="loadInit">
                                <option value="">全部</option>
                                <option v-for="(item, i) in fileClassList" :key="i" :value="item.key">{{item.value}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-md-5 mt-3">
                        <div class="col-12 text-center">
                            <div class="main-table1">
                                <table class="table1">
                                    <thead>
                                        <tr>
                                            <th style="width:20%;">類別</th>
                                            <th style="width:70%;">標題</th>
                                            <th style="width:10%;">下載</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in downloadList" :key="i" :style="(i % 2 == 1? `background-color:#dee2e6;`:`background-color:#ffffff;`)" >
                                            <td data-title="類別" class="text-center">{{item.fileClassStr}}</td>
                                            <td data-title="標題" class="text-center">{{item.title}}</td>
                                            <td data-title="下載" class="text-center">
                                                <a href="javascript:;" @click="downloadPFile(item)">
                                                    <span class="download"><i class="las la-download"></i></span>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-md-5 mt-3">
                        <div class="col-12 text-center">
                            <div class="btn btn-style">
                                <button type="button" class="btn" @click="$router.go(-1);">返回</button>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
		</div>
	 </section>
        </div>
        <cityinfo-footer></cityinfo-footer>
    </div>
</template>
<script>
import header from "./header";
import footer from './footer';
export default {
    components:{
        "cityinfo-header":header,
        "cityinfo-footer":footer
    },
    data(){
        return {
            title:"",
            dept:"",
            fileClass:"",
            fileClassList:[],
            downloadList:[]
        }
    },
    mounted(){
        if(this.getStore(this.$route.name)){
            let param = JSON.parse(this.getStore(this.$route.name));
            this.title = param.title;
            this.dept = param.dept;
        }
        this.$http.get(`/api/Share/FileClass`).then(a => {
            this.fileClassList = a.body;
        });
        this.loadInit();
    },
    methods:{
        loadInit(){
            this.$http.get(`/api/Download/public`,{params:{dept:this.dept, fileClass:this.fileClass}}).then(a => {
                this.downloadList = a.body;
            });
        },
        downloadPFile(obj){
            this.$http.post("/api/Share/fileDownload",JSON.stringify({
                model:obj.filePath,
            }),{
                headers: { "Content-Type": "application/json" },
                responseType: "blob" 
            }).then(res => {
                this.downloadFile(res.body, obj.fileName);
            }).catch(err => {
                console.log(err);
            });
        },
    },
    beforeRouteLeave(to, from, next) {
        this.removeStore(this.$route.name);
		next();
	}
}
</script>